<div *ngIf="componentReady" class="PrecessUpload py-3">
  <div class="ProcessUpload-header">
    <h4>Upload Contacts</h4>
  </div>
  <div class="ProcessUpload-form">
    <div *ngIf="importError" class="alert alert-danger">
      <p>{{ importError }}</p>
    </div>
    <form [formGroup]="formGroup">
      <div class="ProcessUpload-group_select">
        <div class="ProcessUpload-form-header">
          <h4>User Contact Group</h4>
        </div>
        <div class="row">
          <div class="col col-md-12">
            <mat-form-field>
              <mat-label>Select Existing group</mat-label>
              <mat-select
                formControlName="group_id"
                (selectionChange)="onGroupSelection($event)">
                <mat-option
                  *ngFor="let item of contactGroupsItems"
                  [value]="item.value">
                  {{ item.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="showGroupControl" class="row">
          <div class="col col-md-12">
            <mat-form-field>
              <mat-label>Group name:</mat-label>
              <input
                (focusout)="checkNewGroup($event.target.value)"
                matInput
                name="group_name"
                formControlName="group_name" />
            </mat-form-field>
            <div
              *ngIf="
                group_name.touched && !group_name.valid && group_name.errors
              "
              class="alert alert-danger">
              <p *ngIf="group_name.errors.required">Group name is required!</p>
            </div>
          </div>
        </div>
      </div>
      <div class="ProcessUpload-fields_map">
        <div class="ProcessUpload-form-header">
          <h4>Set fields mapping</h4>
        </div>
        <div *ngFor="let row of firstRowKeys" class="row">
          <div class="col col-12 col-md-4">
            <p>{{ row }}</p>
          </div>
          <div class="col col-12 col-md-4">
            <p>{{ firstRow[row] }}</p>
          </div>
          <div class="col col-12 col-md-4">
            <mat-form-field>
              <mat-label>Map to...</mat-label>
              <mat-select formControlName="{{ row }}">
                <mat-option
                  *ngFor="let item of fieldMaps[row]"
                  [value]="item.value">
                  {{ item.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="ProcessUpload-preview">
        <div class="ProcessUpload-form-header">
          <h4>Preview</h4>
        </div>
        <div class="ProcessUpload-preview-container">
          <table
            #previewTable
            mat-table
            [dataSource]="samples"
            class="mat-elevation-z8">
            <ng-container
              *ngFor="let key of filterFunction(firstRowKeys)"
              matColumnDef="{{ key ? key : '' }}">
              <th mat-header-cell *matHeaderCellDef>
                {{ mapping[formGroup.get(key).value] }}
              </th>
              <td mat-cell *matCellDef="let element">{{ element[key] }}</td>
            </ng-container>

            <!-- Star Column -->
            <ng-container matColumnDef="Star" stickyEnd>
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <mat-icon>more_vert</mat-icon>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>

        <!--
                <div class="ProcessUpload-form-row ProcessUpload-form-row-header row">
                    <div *ngFor="let key of firstRowKeys" class="col col-12 col-md-{{getCellNumber()}}">
                        <span>{{mapping[formGroup.get(key).value]}}</span>
                    </div>
                </div>
                <div *ngFor="let item of samples" class="row ProcessUpload-form-row">
                    <div *ngFor="let sampleKey of getSampleKeys(item)" class="col col-12 col-md-{{getCellNumber()}}">
                        <span>{{item[sampleKey]}}</span>
                    </div>
                </div>
                -->
      </div>
    </form>
  </div>
  <div class="ProcessUpload-footer">
    <app-button
      [color]="cancelButtonProperteis.color"
      [text]="cancelButtonProperteis.text"
      [size]="cancelButtonProperteis.size"
      [Click]="cancelButtonProperteis.onClick"></app-button>
    <app-button
      [color]="submitButtonProperties.color"
      [text]="submitButtonProperties.text"
      [size]="submitButtonProperties.size"
      [Click]="submitButtonProperties.onClick"></app-button>
  </div>
</div>
<mat-card
  *ngIf="!componentReady"
  style="display: flex; justify-content: center; align-items: center">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
